module.exports = __webpack_public_path__ + "img/NassKiosk.e7566232.png";